<button type='button'
[ngClass]="buttonStyle"
[disabled]="disabled"
					(click)='showRealTimeInfo()'>
					<svg-icon src='assets/icons/explore.svg'
						class='d-flex flex-wrap'
						[svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
					></svg-icon>
				</button>
<app-vehicle-state [vehicleId]="vehicleId"></app-vehicle-state>